import { supabase } from '../services/supabaseClient';

export async function inserirAtendimento({ nome_cliente, telefone, mensalista, mensalista_id, barbeiro, status = 'ativo' }) {
  const { data, error } = await supabase
    .from('atendimentos')
    .insert([
      {
        nome_cliente,
        telefone,
        mensalista,
        mensalista_id, // novo campo para salvar o id do mensalista
        barbeiro,
        status,
        iniciado_em: new Date().toISOString(),
      },
    ])
    .select()
    .single();

  if (error) throw error;
  return data;
}
